import Seo from "@/components/Seo";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const NAVY = "#0f172a";

const BLOCKS = [
  { t: "meta", text: "Terms Governing Registration and Participation in the ProToCall Labour Registry" },
  { t: "meta", text: "Effective: June 2026 · Governed by the Laws of Saint Lucia" },

  { t: "h", text: "1. About the ProToCall Labour Registry" },
  { t: "p", text: "The ProToCall Labour Registry (the \"Registry\") is a service operated by ProToCall Ltd. that maintains a database of individual skilled workers and tradespeople available for hire. ProToCall connects registered workers with companies, developers, property owners, and other hiring parties (collectively, \"Hiring Companies\") upon request. These Terms of Use (\"Terms\") govern every individual (\"Worker\") who registers with the Registry." },

  { t: "h", text: "2. Nature of the Relationship" },
  { t: "sub", text: "Important — ProToCall is NOT your Employer" },
  { t: "li", text: "Registration with the ProToCall Labour Registry does not create an employment relationship between the Worker and ProToCall Ltd." },
  { t: "li", text: "ProToCall is a referral intermediary only. Workers are independent individuals operating on their own account." },
  { t: "li", text: "ProToCall does not guarantee work, income, or placement for any registered worker." },
  { t: "p", text: "When a Hiring Company engages a Worker through ProToCall, the working arrangement is directly between the Worker and the Hiring Company. ProToCall is not a party to that arrangement and is not responsible for the terms, payment, or conditions of that engagement." },

  { t: "h", text: "3. Registration & Eligibility" },
  { t: "li", text: "Registration is open to any individual skilled worker or tradesperson operating in Saint Lucia or a jurisdiction where ProToCall operates." },
  { t: "li", text: "Registered businesses or companies are not eligible for the Registry — the Registry is for individuals only. Businesses seeking to join ProToCall's contractor network should contact ProToCall separately." },
  { t: "li", text: "Workers must be 18 years of age or older." },
  { t: "li", text: "Workers must be legally permitted to work in Saint Lucia." },
  { t: "li", text: "ProToCall reserves the right to refuse or revoke registration at its sole discretion." },

  { t: "h", text: "4. Registration Fee & Listing Tiers" },
  { t: "table" },
  { t: "li", text: "All registration fees are non-refundable once the Worker's profile has been activated." },
  { t: "li", text: "Workers may upgrade their tier at any time by paying the difference between tiers." },
  { t: "li", text: "There is no annual renewal fee — registration is a one-time payment for lifetime listing, subject to these Terms." },

  { t: "h", text: "5. Worker Responsibilities" },
  { t: "p", text: "By registering, every Worker agrees to:" },
  { t: "li", text: "Provide accurate, truthful, and up-to-date information at all times." },
  { t: "li", text: "Notify ProToCall immediately of any changes to availability, contact details, or trade skills." },
  { t: "li", text: "Conduct themselves professionally and honestly on all jobs to which they are referred." },
  { t: "li", text: "Not misrepresent their skills, experience, or qualifications to a Hiring Company." },
  { t: "li", text: "Not solicit direct future work from a Hiring Company in a manner designed to bypass ProToCall (see Section 8 — Non-Circumvention)." },
  { t: "li", text: "Comply with all applicable laws and safety regulations on any job site." },

  { t: "h", text: "6. ProToCall's Role in Referrals" },
  { t: "p", text: "When a Hiring Company requests workers through the Registry, ProToCall will:" },
  { t: "li", text: "Match the request to available registered workers based on trade, location, availability, and listing tier." },
  { t: "li", text: "Share the Worker's name, trade, contact details, and Registry profile with the Hiring Company." },
  { t: "li", text: "Charge the Hiring Company a flat referral fee of EC$150 per placement." },
  { t: "p", text: "ProToCall does not negotiate wages, set working conditions, or manage the engagement between the Worker and the Hiring Company. Once the referral is made, the Worker is responsible for their own conduct, performance, and payment arrangements with the Hiring Company." },

  { t: "h", text: "7. No Guarantee of Work" },
  { t: "p", text: "Registration in the ProToCall Labour Registry does not guarantee that a Worker will receive any referrals or placements. The volume of referrals depends entirely on demand from Hiring Companies and the Worker's trade, availability, and location. ProToCall makes no representations about expected earnings or frequency of placement." },

  { t: "h", text: "8. Non-Circumvention" },
  { t: "p", text: "Workers agree not to solicit, accept, or enter into any direct working arrangement with a Hiring Company introduced through ProToCall that is specifically designed to bypass ProToCall's referral role. This means:" },
  { t: "li", text: "If a Hiring Company found the Worker through the ProToCall Labour Registry, any further engagement of that Worker by the same company must continue to be processed through ProToCall for a period of twelve (12) months from the date of first referral." },
  { t: "li", text: "Workers must not instruct Hiring Companies to contact them directly and bypass the registry on future occasions." },
  { t: "li", text: "Breach of this clause will result in immediate removal from the Registry without refund." },

  { t: "h", text: "9. Removal from the Registry" },
  { t: "p", text: "ProToCall may remove a Worker from the Registry at any time, with or without prior notice, in the event of:" },
  { t: "li", text: "Providing false information on the registration form." },
  { t: "li", text: "Misconduct, dishonesty, or unprofessional behaviour on a referred job." },
  { t: "li", text: "Breach of the Non-Circumvention clause." },
  { t: "li", text: "A verified complaint from a Hiring Company about the Worker's conduct or performance." },
  { t: "li", text: "Any conduct that brings ProToCall into disrepute." },
  { t: "p", text: "Removal from the Registry is at ProToCall's sole discretion. Registration fees are non-refundable upon removal for breach." },

  { t: "h", text: "10. Privacy" },
  { t: "p", text: "Worker information collected during registration is used solely for the purpose of maintaining the Registry and facilitating referrals to Hiring Companies. ProToCall will share a Worker's name, trade, contact details, and listing tier with Hiring Companies as part of the referral process. ProToCall will not sell or share Worker information with third parties for any other purpose. Workers have the right to request removal of their information from the Registry by contacting ProToCall in writing." },

  { t: "h", text: "11. Limitation of Liability" },
  { t: "p", text: "ProToCall is not liable for any loss, injury, damage, or dispute arising from a Worker's engagement with a Hiring Company introduced through the Registry. The Worker accepts all responsibility for their own safety, conduct, and performance on any referred job. ProToCall's total liability to any Worker under these Terms is limited to the registration fee paid." },

  { t: "h", text: "12. Governing Law" },
  { t: "p", text: "These Terms are governed by the laws of Saint Lucia. Any disputes shall be resolved under Saint Lucian jurisdiction." },

  { t: "h", text: "13. Changes to These Terms" },
  { t: "p", text: "ProToCall reserves the right to update these Terms at any time. Workers will be notified of material changes via the contact details held on file. Continued participation in the Registry after notification of changes constitutes acceptance of the revised Terms." },

  { t: "meta", text: "ProToCall Labour Registry — Version 1.0 · Effective: June 2026" },
  { t: "p", text: "By completing the registration form and submitting payment, you confirm you have read, understood, and agree to these Terms of Use." },
];

const TIER_ROWS = [
  ["Standard", "EC$100 (one-time)", "Listed in the Registry. Referred when trade and availability match a Hiring Company's request."],
  ["Premium", "EC$175 (one-time)", "Priority referral placement. Profile shared first to Hiring Companies. Featured in ProToCall's recommended list."],
  ["Verified Pro", "EC$250 (one-time)", "All Premium benefits plus ProToCall Verified Pro badge. In-person trade skills assessment. Top priority for long-term contract referrals."],
];

export default function TermsOfUsePage() {
  return (
    <div className="bg-white min-h-screen" data-testid="registry-terms-page">
      <Seo
        title="Labour Registry — Worker Terms of Use | ProToCall"
        description="ProToCall Labour Registry Worker Terms of Use. Terms governing registration and participation in the ProToCall Labour Registry, governed by the laws of Saint Lucia."
        path="/labour-registry/terms"
      />
      <div style={{ backgroundColor: NAVY }} className="py-14">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-white">
          <p className="text-sm font-semibold uppercase tracking-wider" style={{ color: "#ffc2b0" }}>
            ProToCall Ltd. · Labour Registry
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mt-2">Worker Terms of Use</h1>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Link to="/labour-registry" className="inline-flex items-center gap-2 text-sm font-semibold mb-8" style={{ color: "#fb3700" }}>
          <ArrowLeft className="w-4 h-4" /> Back to Labour Registry
        </Link>

        <div className="space-y-4">
          {BLOCKS.map((b, i) => {
            if (b.t === "h")
              return <h2 key={i} className="text-xl font-bold pt-6" style={{ color: NAVY }}>{b.text}</h2>;
            if (b.t === "sub")
              return <p key={i} className="font-semibold text-slate-900">{b.text}</p>;
            if (b.t === "meta")
              return <p key={i} className="text-sm text-slate-500">{b.text}</p>;
            if (b.t === "li")
              return (
                <div key={i} className="flex items-start gap-2 text-slate-700">
                  <span className="mt-1.5 w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ backgroundColor: "#fb3700" }} />
                  <p className="leading-relaxed">{b.text}</p>
                </div>
              );
            if (b.t === "table")
              return (
                <div key={i} className="overflow-x-auto rounded-xl border border-slate-200 my-2">
                  <table className="w-full text-left text-sm">
                    <thead>
                      <tr style={{ backgroundColor: NAVY }} className="text-white">
                        <th className="px-4 py-3">Tier</th>
                        <th className="px-4 py-3">Fee</th>
                        <th className="px-4 py-3">Benefits</th>
                      </tr>
                    </thead>
                    <tbody>
                      {TIER_ROWS.map((r, ri) => (
                        <tr key={ri} className={ri % 2 ? "bg-slate-50" : "bg-white"}>
                          <td className="px-4 py-3 font-semibold" style={{ color: NAVY }}>{r[0]}</td>
                          <td className="px-4 py-3 whitespace-nowrap">{r[1]}</td>
                          <td className="px-4 py-3 text-slate-600">{r[2]}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              );
            return <p key={i} className="text-slate-700 leading-relaxed">{b.text}</p>;
          })}
        </div>
      </div>
    </div>
  );
}
